function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15 10a1 1 0 010 2H1a1 1 0 010-2h14zm0-5a1 1 0 010 2H1a1 1 0 110-2h14zm0-5a1 1 0 010 2H1a1 1 0 110-2h14z",
  fill: "currentColor",
  fillRule: "evenodd"
});

function SvgBurgerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgBurgerIcon;